import { useFormikContext } from 'formik';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { CurrencyFieldText } from 'src/components/mui-overrides/Currency';

interface Props {
  disabled?: boolean;
}

export const RentalIncomeField: FC<Props> = ({ disabled }) => {
  const { t } = useTranslation();

  const formik = useFormikContext();

  return (
    <CurrencyFieldText
      disabled={disabled}
      hideHelperText={true}
      size="small"
      label={t('dashboard.assets.addedit.main.rentalincome.fields.rentalincome')}
      fieldName="rentalDetails.rentalIncome"
      formik={formik}
      currency={'€'}
    />
  );
};
